import { useTranslation } from 'react-i18next';
import type { TranslationKey } from '../../i18n/en';
import type { Route } from './useHashRoute';

const TABS: ReadonlyArray<{ route: Route; label: TranslationKey }> = [
    { route: 'tanaan', label: 'tab_today' },
    { route: 'tulevat', label: 'tab_upcoming' },
    { route: 'kausi', label: 'tab_season' },
    { route: 'liiga', label: 'tab_league' },
];

// The four main sections, as plain links to their hash routes.
export function BottomTabs({ route }: { route: Route }) {
    const { t } = useTranslation();

    return (
        <nav className="bottom-tabs" aria-label={t('nav_label')}>
            {TABS.map(tab => (
                <a
                    key={tab.route}
                    href={`#${tab.route}`}
                    aria-current={tab.route === route ? 'page' : undefined}
                    className={tab.route === route ? 'on' : undefined}
                >
                    {t(tab.label)}
                </a>
            ))}
        </nav>
    );
}
